import React from 'react';

export const FeedbackContext = React.createContext({});
